import React from 'react';
import { Route, Switch }  from 'react-router-dom';
import NotFound from "../NotFound";
import Home from "../Home";
import SimpleSearchMwe from '../MweSearch/SimpleSearch';
import AdvancedSearchMwe from '../MweSearch/AdvancedSearch';
import SearchHelp from '../MweSearch/SearchHelp';
import TagMwe from '../MweTagger';
import TaggerHelp from '../MweTagger/MweTaggerHelp';
import ResourceList from '../ResourceList';
import LearningAppHelp from '../LearningApp/LearningAppHelp';
import Assignment from "../LearningApp/LearningApp/Assignment";


export default () => {
  return (
    <Switch>
      <Route exact path="/" component={Home}/>
      <Route exact path="/paieska/paprastoji" component={SimpleSearchMwe}/>
      <Route exact path="/paieska/isplestine" component={AdvancedSearchMwe}/>
      <Route exact path="/paieska/apie" component={SearchHelp}/>
      <Route exact path="/paieska" component={SimpleSearchMwe}/>
      <Route exact path="/atpazintuvas" component={TagMwe}/>
      <Route exact path="/atpazintuvas/apie" component={TaggerHelp}/>
      <Route exact path="/atsisiusti" component={ResourceList}/>
      <Route exact path="/mokomoji-priemone/apie" component={LearningAppHelp}/>
      <Route exact path="/mokomoji-priemone/1-dalis/:id" component={Assignment}/>
      <Route exact path="/mokomoji-priemone/2-dalis/:id" component={Assignment}/>
      <Route path="*" component={NotFound}/>
    </Switch>
  );
}